var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFireGenCampaign = function SvgIconFireGenCampaign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_fire_gen_campaign_svg__a)",
    d: "M10 18.836c3.544 0 6.666-2.5 6.666-5.833s-2.5-5-3.333-5.834c-1.085-1.084-1.48-2.485-1.617-3.527-.092-.702-.774-1.195-1.347-.78-.942.68-2.168 1.97-2.87 4.307-.535 1.785 0 3.334 0 3.334s-.833-.417-1.25-1.667a36 36 0 0 0-.358-1.014c-.31-.845-1.447-.836-1.714.024-.42 1.354-.844 3.038-.844 4.323 0 4.167 3.123 6.667 6.667 6.667"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_fire_gen_campaign_svg__a",
    x1: 8.618,
    x2: 12.995,
    y1: 13.046,
    y2: -0.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })))));
};
export default SvgIconFireGenCampaign;